/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type { LunchTemplate, LunchTemplateRequest } from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getGetLunchTemplatesUrl = () => {
  return `/api/v1/lunch-templates`
}

/**
 * @summary The saved lunch templates
 */
export const getLunchTemplates = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<LunchTemplate[]> => {
  return customFetch<LunchTemplate[]>(getGetLunchTemplatesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetLunchTemplatesQueryKey = () => {
  return [`/api/v1/lunch-templates`] as const
}

export const getGetLunchTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLunchTemplates>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLunchTemplates>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetLunchTemplatesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLunchTemplates>>> = ({ signal }) =>
    getLunchTemplates({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLunchTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLunchTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLunchTemplates>>
>
export type GetLunchTemplatesQueryError = unknown

export function useGetLunchTemplates<
  TData = Awaited<ReturnType<typeof getLunchTemplates>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLunchTemplates>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLunchTemplates>>,
          TError,
          Awaited<ReturnType<typeof getLunchTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLunchTemplates<
  TData = Awaited<ReturnType<typeof getLunchTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLunchTemplates>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLunchTemplates>>,
          TError,
          Awaited<ReturnType<typeof getLunchTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLunchTemplates<
  TData = Awaited<ReturnType<typeof getLunchTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLunchTemplates>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The saved lunch templates
 */

export function useGetLunchTemplates<
  TData = Awaited<ReturnType<typeof getLunchTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLunchTemplates>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetLunchTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostLunchTemplatesUrl = () => {
  return `/api/v1/lunch-templates`
}

/**
 * @summary Save a week as a named template
 */
export const postLunchTemplates = async (
  lunchTemplateRequest: LunchTemplateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<LunchTemplate> => {
  return customFetch<LunchTemplate>(getPostLunchTemplatesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lunchTemplateRequest),
  })
}

export const getPostLunchTemplatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLunchTemplates>>,
    TError,
    { data: LunchTemplateRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLunchTemplates>>,
  TError,
  { data: LunchTemplateRequest },
  TContext
> => {
  const mutationKey = ['postLunchTemplates']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLunchTemplates>>,
    { data: LunchTemplateRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postLunchTemplates(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostLunchTemplatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLunchTemplates>>
>
export type PostLunchTemplatesMutationBody = LunchTemplateRequest
export type PostLunchTemplatesMutationError = unknown

/**
 * @summary Save a week as a named template
 */
export const usePostLunchTemplates = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLunchTemplates>>,
      TError,
      { data: LunchTemplateRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLunchTemplates>>,
  TError,
  { data: LunchTemplateRequest },
  TContext
> => {
  return useMutation(getPostLunchTemplatesMutationOptions(options), queryClient)
}
export const getDeleteLunchTemplatesIdUrl = (id: number) => {
  return `/api/v1/lunch-templates/${id}`
}

/**
 * @summary Remove a template
 */
export const deleteLunchTemplatesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteLunchTemplatesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteLunchTemplatesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLunchTemplatesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLunchTemplatesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteLunchTemplatesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLunchTemplatesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteLunchTemplatesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteLunchTemplatesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLunchTemplatesId>>
>

export type DeleteLunchTemplatesIdMutationError = unknown

/**
 * @summary Remove a template
 */
export const useDeleteLunchTemplatesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLunchTemplatesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLunchTemplatesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteLunchTemplatesIdMutationOptions(options), queryClient)
}
export const getPatchLunchTemplatesIdUrl = (id: number) => {
  return `/api/v1/lunch-templates/${id}`
}

/**
 * @summary Rename a template, replace its week, or make it the default
 */
export const patchLunchTemplatesId = async (
  id: number,
  lunchTemplateRequest: LunchTemplateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<LunchTemplate> => {
  return customFetch<LunchTemplate>(getPatchLunchTemplatesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lunchTemplateRequest),
  })
}

export const getPatchLunchTemplatesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchLunchTemplatesId>>,
    TError,
    { id: number; data: LunchTemplateRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchLunchTemplatesId>>,
  TError,
  { id: number; data: LunchTemplateRequest },
  TContext
> => {
  const mutationKey = ['patchLunchTemplatesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchLunchTemplatesId>>,
    { id: number; data: LunchTemplateRequest }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchLunchTemplatesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchLunchTemplatesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchLunchTemplatesId>>
>
export type PatchLunchTemplatesIdMutationBody = LunchTemplateRequest
export type PatchLunchTemplatesIdMutationError = unknown

/**
 * @summary Rename a template, replace its week, or make it the default
 */
export const usePatchLunchTemplatesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchLunchTemplatesId>>,
      TError,
      { id: number; data: LunchTemplateRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchLunchTemplatesId>>,
  TError,
  { id: number; data: LunchTemplateRequest },
  TContext
> => {
  return useMutation(getPatchLunchTemplatesIdMutationOptions(options), queryClient)
}
